(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7605],{

/***/ 24666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OriginalAutoForm": function() { return /* binding */ OriginalAutoForm; },
/* harmony export */   "default": function() { return /* binding */ InternalAutoForm; },
/* harmony export */   "getField": function() { return /* binding */ getField; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _packages_orionjs_react_autoform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37682);
/* harmony import */ var _providers_apollo_getClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98751);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32533);
/* harmony import */ var _fields__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64087);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var getField = function(fieldName) {
    return _fields__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z[fieldName];
};
var OriginalAutoForm = (0,_packages_orionjs_react_autoform__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    getField: getField,
    getDefaultLabel: function() {
        return "Valor";
    },
    getClient: function() {
        return (0,_providers_apollo_getClient__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    },
    onError: function(error) {
        if (error.extra && error.extra.hash) {
            alert("\uD83D\uDD0E Ocurri\xf3 un error\n\n        Si el error persiste, puedes enviar el siguiente c\xf3digo a soporte: ".concat(error.extra.hash, "\n      "));
        } else {
            alert(error.message);
        }
    },
    getErrorText: function(code, field) {
        return next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .i18n.t */ .ag.t("errors.".concat(code), {
            label: field.label,
            ns: "deprecated"
        });
    },
    loading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: "Cargando..."
    })
});
function InternalAutoForm(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OriginalAutoForm, _objectSpread({}, props, {
        ref: props.forwardedRef
    }));
};


/***/ }),

/***/ 67605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _AutoForm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24666);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




// Dynamically imported component
var InternalAutoForm = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 24666)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24666)
            ];
        }
    },
    ssr: false
});
var WrappedAutoForm = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InternalAutoForm, _objectSpread({}, props, {
        forwardedRef: ref
    }));
});
WrappedAutoForm.displayName = "WrappedAutoForm";
var AutoForm = WrappedAutoForm;
AutoForm.getFieldComponent = _AutoForm__WEBPACK_IMPORTED_MODULE_3__.getField;
AutoForm.getField = _AutoForm__WEBPACK_IMPORTED_MODULE_3__.getField;
/* harmony default export */ __webpack_exports__["Z"] = (AutoForm);


/***/ }),

/***/ 68182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomCheckbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _packages_justo_parts_lib_components_fields_Checkbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3040);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42889);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function CustomCheckbox(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_fields_Checkbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props)),
            props.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().description),
                children: props.description
            }) : null
        ]
    });
};


/***/ }),

/***/ 94083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Money; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useEffect.ts
var useEffect = __webpack_require__(10338);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./src/i18n/formatNumber/index.ts + 1 modules
var formatNumber = __webpack_require__(78263);
// EXTERNAL MODULE: ./node_modules/lodash/isNumber.js
var isNumber = __webpack_require__(81763);
var isNumber_default = /*#__PURE__*/__webpack_require__.n(isNumber);
;// CONCATENATED MODULE: ./src/components/fields/Money/Input/getPrettyText.ts


/* harmony default export */ function getPrettyText(value) {
    if (!isNumber_default()(value)) return "";
    var textValue = (0,formatNumber/* default */.Z)(value, "$0,0.[000000000000000000000]");
    return textValue;
};

;// CONCATENATED MODULE: ./src/components/fields/Money/Input/getTextFromNumber.ts


/* harmony default export */ function getTextFromNumber(value) {
    if (!isNumber_default()(value)) return "";
    var textValue = (0,formatNumber/* default */.Z)(value, "0.[000000000000000000000]");
    return textValue;
};

// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
;// CONCATENATED MODULE: ./src/components/fields/Money/Input/getValueFromText.ts

/* harmony default export */ function getValueFromText(text) {
    if (!text) return null;
    return numeral_default()(text).value();
};

;// CONCATENATED MODULE: ./src/components/fields/Money/Input/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







function Input(props) {
    var value = props.value, onChange = props.onChange, passProps = props.passProps, placeholder = props.placeholder;
    var ref = _slicedToArray((0,useState/* default */.Z)(getTextFromNumber(value)), 2), textValue = ref[0], setTextValue = ref[1];
    var ref1 = _slicedToArray((0,useState/* default */.Z)(false), 2), focused = ref1[0], setFocused = ref1[1];
    (0,useEffect/* default */.Z)(function() {
        if (focused) return;
        var newTextValue = getTextFromNumber(value);
        if (textValue !== newTextValue) {
            setTextValue(newTextValue);
        }
    }, [
        value,
        focused
    ]);
    var updateValue = function(text) {
        var valueFromText = getValueFromText(text);
        onChange(valueFromText);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
        className: "os-input-text",
        value: focused ? textValue : getPrettyText(value),
        onChange: function(event) {
            setTextValue(event.target.value);
            updateValue(event.target.value);
        },
        onFocus: function() {
            setFocused(true);
            if (passProps.onFocus) {
                passProps.onFocus();
            }
        },
        onBlur: function(event) {
            setFocused(false);
            if (passProps.onBlur) {
                passProps.onBlur(event);
            }
        },
        onKeyDown: function(event) {
            if (passProps.onKeyDown) {
                passProps.onKeyDown(event);
            }
        },
        placeholder: placeholder
    });
};

// EXTERNAL MODULE: ./src/components/fields/Money/styles.module.css
var styles_module = __webpack_require__(35901);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/fields/Money/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function Money(props) {
    var label = props.label, description = props.description, errorMessage = props.errorMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "label",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "os-input-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, _objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "description",
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "os-input-error",
                children: errorMessage
            })
        ]
    });
};


/***/ }),

/***/ 44682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Phone; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useCountryCode.ts
var useCountryCode = __webpack_require__(50900);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Text/index.js
var Text = __webpack_require__(55672);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(82723);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
;// CONCATENATED MODULE: ./src/components/fields/Phone/getValue.ts
/* harmony default export */ function getValue(value, starter) {
    if (!value) return "";
    if (!value.startsWith(starter)) return "";
    return (value || "").replace(new RegExp("^\\".concat(starter)), "");
};

;// CONCATENATED MODULE: ./src/components/fields/Phone/locales.ts
/* harmony default export */ var locales = ({
    MX: "+52",
    CL: "+56",
    PE: "+51",
    CO: "+57",
    EC: "+593",
    CR: "+506",
    AR: "+54"
});

// EXTERNAL MODULE: ./src/components/fields/Phone/styles.module.css
var styles_module = __webpack_require__(41423);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/fields/Phone/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}








function Phone(props) {
    var websiteCountryCode = props.parentValue ? props.parentValue.countryCode : null;
    var countryCode = (0,useCountryCode/* default */.Z)();
    var starter = locales[websiteCountryCode] || locales[countryCode] || locales.CL;
    var val = getValue(props.value, starter);
    var onChange = function(text) {
        var numbers = text.replace(/\D/g, "");
        if (!numbers) {
            props.onChange(null);
        } else {
            props.onChange(starter + numbers);
        }
    };
    var passingProps = omit_default()(props, "errorMessage");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).digit,
                        children: starter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, _objectSpread({}, passingProps, {
                        value: val,
                        onChange: onChange,
                        autoComplete: "tel-national"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "description",
                children: props.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "os-input-error",
                children: props.errorMessage
            })
        ]
    });
};


/***/ }),

/***/ 64661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SixDigitInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var autobind_decorator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88572);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96026);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_range__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4972);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc1 = {};
    Object.keys(descriptor).forEach(function(key) {
        desc1[key] = descriptor[key];
    });
    desc1.enumerable = !!desc1.enumerable;
    desc1.configurable = !!desc1.configurable;
    if ("value" in desc1 || desc1.initializer) {
        desc1.writable = true;
    }
    desc1 = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator ? decorator(target, property, desc) || desc : desc;
    }, desc1);
    var hasAccessor = Object.prototype.hasOwnProperty.call(desc1, "get") || Object.prototype.hasOwnProperty.call(desc1, "set");
    if (context && desc1.initializer !== void 0 && !hasAccessor) {
        desc1.value = desc1.initializer ? desc1.initializer.call(context) : void 0;
        desc1.initializer = undefined;
    }
    if (hasAccessor) {
        delete desc1.writable;
        delete desc1.initializer;
        delete desc1.value;
    }
    if (desc1.initializer === void 0) {
        Object.defineProperty(target, property, desc1);
        desc1 = null;
    }
    return desc1;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}






var _Component, _SixDigitInput;
var _class, _dec, _dec1, _dec2, _dec3;
var SixDigitInput = ((_class = (_SixDigitInput = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(SixDigitInput, _superClass);
    var _super = _createSuper(SixDigitInput);
    function SixDigitInput(props) {
        _classCallCheck(this, SixDigitInput);
        var _this;
        _this = _super.call(this, props);
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsQty' does not exist on type 'SixDi... Remove this comment to see the full error message
        _this.inputsQty = 6;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsRefs' does not exist on type 'SixD... Remove this comment to see the full error message
        _this.inputsRefs = {};
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsQty' does not exist on type 'SixDi... Remove this comment to see the full error message
        lodash_range__WEBPACK_IMPORTED_MODULE_2___default()(_this.inputsQty).forEach(function(index) {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsRefs' does not exist on type 'SixD... Remove this comment to see the full error message
            _this.inputsRefs["input_".concat(index)] = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createRef();
        });
        return _this;
    }
    var _proto = SixDigitInput.prototype;
    _proto.componentDidMount = function componentDidMount() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'autoFocus' does not exist on type 'Reado... Remove this comment to see the full error message
        if (this.props.autoFocus) {
            this.focus();
        }
    };
    _proto.focus = function focus() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
        if (this.props.value) {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
            this.props.onChange("");
        }
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsRefs' does not exist on type 'SixD... Remove this comment to see the full error message
        this.inputsRefs["input_0"].current.focus();
    };
    _proto.getNextIndex = function getNextIndex(value) {
        if (!value) return 0;
        if (value.length > 5) return 0;
        return value.length;
    };
    _proto.focusNext = function focusNext() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
        var value = this.props.value;
        var index = this.getNextIndex(value);
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsRefs' does not exist on type 'SixD... Remove this comment to see the full error message
        this.inputsRefs["input_".concat(index)].current.focus();
    };
    _proto.isReady = function isReady() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
        return (this.props.value || "").length === 6;
    };
    _proto.onChange = function onChange(event, index) {
        var _this = this;
        var value = event.target.value || "";
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
        var oldValue = this.props.value || "";
        var newValue = oldValue + value;
        if (newValue.length > 6) {
            var last = newValue[newValue.length - 1];
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
            this.props.onChange(last);
        } else {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
            this.props.onChange(newValue);
        }
        setTimeout(function() {
            if (_this.isReady()) {
                var _this1 = _this;
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsRefs' does not exist on type 'SixD... Remove this comment to see the full error message
                _this.inputsRefs["input_".concat(index)].current.blur();
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'onReady' does not exist on type 'Readonl... Remove this comment to see the full error message
                setTimeout(function() {
                    return _this1.props.onReady(newValue);
                }, 200);
            } else {
                _this.focusNext();
            }
        }, 1);
    };
    _proto.onKeyDown = function onKeyDown(event, index) {
        if (event.key === "Backspace") {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
            var newVal = (this.props.value || "1").slice(0, -1);
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
            this.props.onChange(newVal);
            setTimeout(this.focusNext, 1);
        }
    };
    _proto.renderInputs = function renderInputs() {
        var _this = this;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsQty' does not exist on type 'SixDi... Remove this comment to see the full error message
        return lodash_range__WEBPACK_IMPORTED_MODULE_2___default()(this.inputsQty).map(function(index) {
            var _this2 = _this;
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
            var value = (_this.props.value || "")[index] || "";
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                value: value,
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsRefs' does not exist on type 'SixD... Remove this comment to see the full error message
                ref: _this.inputsRefs["input_".concat(index)],
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().input),
                placeholder: "\u2022",
                onChange: function(event) {
                    return _this2.onChange(event, index);
                },
                onKeyDown: function(event) {
                    return _this2.onKeyDown(event, index);
                },
                type: "tel"
            }, index);
        });
    };
    _proto.render = function render() {
        var className = this.isReady() ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().ready) : (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().container);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            onClick: this.focus,
            children: this.renderInputs()
        });
    };
    return SixDigitInput;
}(_Component = react__WEBPACK_IMPORTED_MODULE_1__.Component), _SixDigitInput.propTypes = {
    value: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    onChange: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
    autoFocus: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    onReady: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func)
}, _SixDigitInput.defaultProps = {
    autoFocus: true,
    onReady: function() {}
}, _SixDigitInput)) || _class, _dec = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec1 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", []), _applyDecoratedDescriptor(_class.prototype, "focus", [
    autobind_decorator__WEBPACK_IMPORTED_MODULE_5__["default"],
    _dec,
    _dec1
], Object.getOwnPropertyDescriptor(_class.prototype, "focus"), _class.prototype), _dec2 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec3 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", []), _applyDecoratedDescriptor(_class.prototype, "focusNext", [
    autobind_decorator__WEBPACK_IMPORTED_MODULE_5__["default"],
    _dec2,
    _dec3
], Object.getOwnPropertyDescriptor(_class.prototype, "focusNext"), _class.prototype), _class);



/***/ }),

/***/ 1955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Stores; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/hooks/useWebsiteRole.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getMyWebsiteRole($websiteId: ID) {\n        me {\n          _id\n          roleInWebsite(websiteId: $websiteId) {\n            _id\n            role\n            storesIds\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useWebsiteRole() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var me = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first"
    }).me;
    if (!me || !me.roleInWebsite) return null;
    return me.roleInWebsite;
};

;// CONCATENATED MODULE: ./src/hooks/useWebsiteRoleStoresIds.ts

function useWebsiteRoleStoresIds() {
    var myRole = useWebsiteRole();
    if (!myRole || !myRole.storesIds || !myRole.storesIds.length) return null;
    return myRole.storesIds;
};

// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Select/index.js
var Select = __webpack_require__(97338);
;// CONCATENATED MODULE: ./src/components/fields/Stores/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Stores_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Stores_templateObject() {
    var data = Stores_taggedTemplateLiteral([
        "\n      query getStoresStoresField($websiteId: ID) {\n        stores(websiteId: $websiteId) {\n          items {\n            value: _id\n            label: name\n          }\n        }\n      }\n    "
    ]);
    Stores_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function Stores(props) {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var ref = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(Stores_templateObject()),
        variables: {
            websiteId: websiteId
        },
        partial: true
    }), stores = ref.stores, loading = ref.loading;
    var userStoresIds = useWebsiteRoleStoresIds();
    if (stores && props.filterByRole && userStoresIds) {
        stores.items = stores.items.filter(function(store) {
            return userStoresIds.includes(store.value);
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: props.containerClassName,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, _objectSpread({
            multi: props.multi !== false
        }, props, props.passProps, {
            options: stores ? stores.items : [],
            isLoading: loading,
            placeholder: props.placeholder || "Selecciona un local"
        }))
    });
};


/***/ }),

/***/ 64087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ fields; }
});

// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/DateText/index.js
var DateText = __webpack_require__(56475);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/numeral/Number.js
var numeral_Number = __webpack_require__(42098);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Select/index.js
var Select = __webpack_require__(97338);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Text/index.js
var Text = __webpack_require__(55672);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Textarea/index.js
var Textarea = __webpack_require__(22052);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-sortable-hoc/dist/react-sortable-hoc.esm.js + 1 modules
var react_sortable_hoc_esm = __webpack_require__(43443);
// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(40076);
// EXTERNAL MODULE: ./node_modules/lodash/without.js
var without = __webpack_require__(82569);
var without_default = /*#__PURE__*/__webpack_require__.n(without);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/simple-react-form/lib/index.js
var lib = __webpack_require__(40191);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./src/components/fields/ArrayComponent/Item/styles.module.css
var styles_module = __webpack_require__(10754);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/fields/ArrayComponent/Item/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





function Item(props) {
    var label = props.label, index = props.index, _defaultShow = props.defaultShow, defaultShow = _defaultShow === void 0 ? false : _defaultShow, children = props.children;
    var ref = _slicedToArray((0,useState/* default */.Z)(defaultShow), 2), show = ref[0], setShow = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).header,
                onClick: function() {
                    return setShow(!show);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).label,
                        children: label ? label : "#".concat(index + 1)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaChevronUp */.s$2, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaChevronDown */.RiI, {})
                    })
                ]
            }),
            show ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).content,
                children: children
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/fields/ArrayComponent/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}










// Sortable Elements
var SortableItem = (0,react_sortable_hoc_esm/* SortableElement */.W8)(function(param) {
    var item = param.item;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: item
    });
});
var SortableList = (0,react_sortable_hoc_esm/* SortableContainer */.JN)(function(param) {
    var items = param.items, draggable = param.draggable;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: items.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SortableItem, {
                disabled: !draggable,
                index: index,
                item: item
            }, "item-".concat(index));
        })
    });
});
var ArrayComponent_Array = /*#__PURE__*/ function(ArrayComponent1) {
    "use strict";
    _inherits(Array, ArrayComponent1);
    var _super = _createSuper(Array);
    function Array() {
        _classCallCheck(this, Array);
        return _super.apply(this, arguments);
    }
    var _proto = Array.prototype;
    _proto.removeItem = function removeItem(index) {
        var value = this.props.value || [];
        var newArray = without_default()(value, value[index]);
        this.props.onChange(newArray);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var _props = this.props, _autoSave = _props.autoSave, autoSave = _autoSave === void 0 ? false : _autoSave;
        if (autoSave) this.props.onChange(this.props.value);
    };
    _proto.renderRemoveButton = function renderRemoveButton(index) {
        var _this = this;
        if (!this.props.showRemoveButton) return;
        if (this.props.disabled) return;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: this.props.useAccordion ? "os-array-accordion-item-remove" : "os-array-item-remove",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                danger: true,
                onClick: function() {
                    return _this.removeItem(index);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdCancel */.B4e, {})
            })
        });
    };
    _proto.renderAddButton = function renderAddButton() {
        var _this = this;
        if (!this.props.showAddButton) return;
        if (this.props.disabled) return;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            primary: true,
            label: this.props.addLabel,
            onClick: function() {
                return _this.addItem();
            }
        });
    };
    // this function return the specific field
    _proto.renderChildrenItem = function renderChildrenItem(param) {
        var item = param.item, index = param.index, children = param.children;
        if (this.props.useAccordion) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                index: index,
                defaultShow: index === 0,
                label: item.accordionLabel && item.accordionLabel.length > 0 ? item.accordionLabel : null,
                item: item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "os-array-accordion-item-content",
                        children: this.renderChildrenItemWithContext({
                            index: index,
                            children: children
                        })
                    }),
                    this.renderRemoveButton(index)
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: this.props.childrenClassName,
            style: !this.props.draggable ? {
                cursor: "initial"
            } : null,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "os-array-item-content",
                    children: this.renderChildrenItemWithContext({
                        index: index,
                        children: children
                    })
                }),
                this.renderRemoveButton(index)
            ]
        }, "".concat(this.props.fieldName, ".").concat(index));
    };
    // Render children according to elements inside value
    _proto.renderChildren = function renderChildren() {
        var _this = this;
        var value = this.props.value || [];
        if (this.props.autoAddItem && !this.props.disabled && value.length === 0) {
            value.push({});
        }
        var items = value.map(function(item, index) {
            var children = _this.getChildrenComponents(item, index);
            return _this.renderChildrenItem({
                item: item,
                index: index,
                children: children
            });
        });
        var onSortEnd = function(param) {
            var oldIndex = param.oldIndex, newIndex = param.newIndex;
            return _this.props.onChange((0,react_sortable_hoc_esm/* arrayMove */.Rp)(value, oldIndex, newIndex));
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SortableList, {
            helperClass: this.props.showStyle ? "os-s-array-grabbing" : "",
            distance: 2,
            items: items,
            draggable: this.props.draggable,
            onSortEnd: onSortEnd
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                marginTop: 20
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: this.props.label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        color: "red"
                    },
                    children: this.props.errorMessage
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: this.props.useAccordion ? "os-array-accordion" : this.props.parentClassName,
                    children: this.renderChildren()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginTop: 10,
                        marginBottom: 10
                    },
                    children: this.renderAddButton()
                })
            ]
        });
    };
    return Array;
}(lib.ArrayComponent);
ArrayComponent_Array.propTypes = _objectSpread({}, lib.ArrayComponent.propTypes, {
    childrenClassName: (prop_types_default()).string,
    draggable: (prop_types_default()).bool,
    showRemoveButton: (prop_types_default()).bool,
    useAccordion: (prop_types_default()).bool,
    accordionLabel: (prop_types_default()).string,
    showStyle: (prop_types_default()).bool
});
ArrayComponent_Array.defaultProps = _objectSpread({}, lib.ArrayComponent.defaultProps, {
    childrenClassName: "os-s-array os-s-array-1",
    draggable: false,
    showRemoveButton: true,
    useAccordion: false,
    accordionLabel: "",
    showStyle: true
});


// EXTERNAL MODULE: ./src/components/fields/Checkbox/index.tsx
var Checkbox = __webpack_require__(68182);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/V3/loadingIndicators/Spinner/index.tsx
var Spinner = __webpack_require__(18899);
// EXTERNAL MODULE: ./src/helpers/dayjs/index.ts
var dayjs = __webpack_require__(70457);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/es/index.js + 5 modules
var es = __webpack_require__(63345);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(39450);
// EXTERNAL MODULE: ./src/components/fields/DatePicker/styles.module.css
var DatePicker_styles_module = __webpack_require__(70898);
var DatePicker_styles_module_default = /*#__PURE__*/__webpack_require__.n(DatePicker_styles_module);
;// CONCATENATED MODULE: ./src/components/fields/DatePicker/index.tsx
function DatePicker_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function DatePicker_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function DatePicker_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DatePicker_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function DatePicker_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function DatePicker_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DatePicker_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function DatePicker_slicedToArray(arr, i) {
    return DatePicker_arrayWithHoles(arr) || DatePicker_iterableToArrayLimit(arr, i) || DatePicker_unsupportedIterableToArray(arr, i) || DatePicker_nonIterableRest();
}
function DatePicker_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return DatePicker_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DatePicker_arrayLikeToArray(o, minLen);
}










var OriginalDatePicker = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", DatePicker_objectSpread({}, props));
};
var datePickerLoaded = false;
function DatePicker(param) {
    var label = param.label, tmp = param.startDate, propStartDate = tmp === void 0 ? (0,dayjs/* default */.Z)() : tmp, tmp1 = param.endDate, propEndDate = tmp1 === void 0 ? (0,dayjs/* default */.Z)() : tmp1, onChange = param.onChange, message = param.message, _extraProps = param.extraProps, extraProps = _extraProps === void 0 ? {} : _extraProps, _isRange = param.isRange, isRange = _isRange === void 0 ? false : _isRange, _dateFormat = param.dateFormat, dateFormat = _dateFormat === void 0 ? "dd/MMM/yyyy" : _dateFormat;
    var ref = DatePicker_slicedToArray((0,useState/* default */.Z)(propStartDate), 2), internalStart = ref[0], setInternalStart = ref[1];
    var ref1 = DatePicker_slicedToArray((0,useState/* default */.Z)(propEndDate), 2), internalEnd = ref1[0], setInternalEnd = ref1[1];
    var ref2 = DatePicker_slicedToArray((0,useState/* default */.Z)(false), 2), isOpen = ref2[0], setIsOpen = ref2[1];
    var ref3 = DatePicker_slicedToArray((0,useState/* default */.Z)(datePickerLoaded), 2), isChunkLoading = ref3[0], setIsChunkLoading = ref3[1];
    var clickPicker = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (datePickerLoaded) {
                            _ctx.next = 8;
                            break;
                        }
                        setIsChunkLoading(true);
                        _ctx.next = 5;
                        return __webpack_require__.e(/* import() */ 9198).then(__webpack_require__.t.bind(__webpack_require__, 9198, 23));
                    case 5:
                        OriginalDatePicker = _ctx.sent.default;
                        setIsChunkLoading(false);
                        datePickerLoaded = true;
                    case 8:
                        setIsOpen(true);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function clickPicker(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var close = function() {
        setTimeout(function() {
            return setIsOpen(false);
        }, 50);
    };
    var resetEnd = function() {
        setInternalEnd(null);
    };
    var handleChange = function(dates) {
        if (isRange) {
            var startDate = (0,dayjs/* default */.Z)(dates[0]);
            var endDate = dates[1] ? (0,dayjs/* default */.Z)(dates[1]) : null;
            setInternalStart(startDate);
            setInternalEnd(endDate);
            if (startDate && endDate) onChange([
                startDate,
                endDate
            ], {
                resetEnd: resetEnd,
                close: close
            });
        } else {
            setInternalStart((0,dayjs/* default */.Z)(dates));
            onChange((0,dayjs/* default */.Z)(dates), close);
        }
    };
    var handleClickOutside = function() {
        if (isRange) {
            if (internalStart && !internalEnd || internalStart.diff(propStartDate, "days") === 0 && internalEnd.diff(propEndDate, "days") === 0) {
                setInternalStart(propStartDate);
                setInternalEnd(propEndDate);
            }
        }
        close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (DatePicker_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (DatePicker_styles_module_default()).label,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (DatePicker_styles_module_default()).datePickerContainer,
                onClick: clickPicker,
                style: isOpen ? {
                    border: "2px solid #2684FF",
                    padding: 0
                } : {},
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OriginalDatePicker, DatePicker_objectSpread({
                        open: isOpen,
                        className: (DatePicker_styles_module_default()).datePicker,
                        selected: internalStart.toDate(),
                        startDate: internalStart.toDate(),
                        endDate: internalEnd ? internalEnd.toDate() : null,
                        onChange: handleChange,
                        selectsRange: isRange,
                        dateFormat: dateFormat,
                        closeOnScroll: true,
                        onClickOutside: handleClickOutside,
                        locale: es/* default */.Z,
                        disabledKeyboardNavigation: true
                    }, extraProps, {
                        children: isChunkLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : null
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (DatePicker_styles_module_default()).separator
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdInsertInvitation */.IwC, {
                        size: 38,
                        className: (DatePicker_styles_module_default()).icon,
                        style: isOpen ? {
                            color: "rgb(102, 102, 102)"
                        } : {}
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/isNull.js
var isNull = __webpack_require__(45220);
var isNull_default = /*#__PURE__*/__webpack_require__.n(isNull);
// EXTERNAL MODULE: ./src/components/fields/DateTime/styles.module.css
var DateTime_styles_module = __webpack_require__(44122);
var DateTime_styles_module_default = /*#__PURE__*/__webpack_require__.n(DateTime_styles_module);
;// CONCATENATED MODULE: ./src/components/fields/DateTime/index.tsx
function DateTime_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function DateTime_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function DateTime_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function DateTime_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function DateTime_slicedToArray(arr, i) {
    return DateTime_arrayWithHoles(arr) || DateTime_iterableToArrayLimit(arr, i) || DateTime_unsupportedIterableToArray(arr, i) || DateTime_nonIterableRest();
}
function DateTime_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return DateTime_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DateTime_arrayLikeToArray(o, minLen);
}










var TIME_FORMAT = "HH:mm:ss";
var DATE_FORMAT = "DD-MM-YYYY";
function DateTime(props) {
    var ref = DateTime_slicedToArray((0,useState/* default */.Z)(null), 2), hourState = ref[0], setHourState = ref[1];
    var timeFormat = props.timeFormat ? props.timeFormat : TIME_FORMAT;
    var dateFormat = props.dateFormat ? props.dateFormat : DATE_FORMAT;
    var hourValue = isNull_default()(hourState) ? props.value ? (0,dayjs/* default */.Z)(props.value).format(timeFormat) : "" : hourState;
    var checkHour = function() {
        var parsed = (0,dayjs/* default */.Z)(hourState, timeFormat);
        if (!parsed.isValid()) {
            setHourState(null);
            return;
        }
        var finalDate = "".concat((0,dayjs/* default */.Z)(props.value).format(dateFormat), " ").concat(parsed.format(timeFormat));
        var date = (0,dayjs/* default */.Z)(finalDate, dateFormat + " " + timeFormat);
        props.onChange(date.toDate());
        setHourState(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "label",
                children: props.label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (DateTime_styles_module_default()).inputs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-xs-12 col-sm-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateText/* default */.Z, {
                                value: props.value,
                                onChange: props.onChange
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-xs-12 col-sm-5",
                            children: props.value ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                value: hourValue,
                                onChange: setHourState,
                                passProps: {
                                    onBlur: checkHour
                                },
                                onEnter: checkHour
                            }) : null
                        }),
                        props.hideCalendar ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-xs-12 col-sm-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                icon: index_esm/* MdDateRange */.f$3,
                                onClick: function() {
                                    return props.onChange((0,dayjs/* default */.Z)().startOf("week").add(1, "week").add(12, "hours").toDate());
                                },
                                children: "Lunes"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "description",
                children: [
                    props.value ? (0,dayjs/* default */.Z)(props.value).format("LLL") + ". " : "",
                    props.description
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "os-input-error",
                children: props.errorMessage
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/autobind-decorator/lib/esm/index.js
var esm = __webpack_require__(88572);
// EXTERNAL MODULE: ./node_modules/lodash/clone.js
var clone = __webpack_require__(66678);
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/decorators/withMessage.js
var withMessage = __webpack_require__(77543);
// EXTERNAL MODULE: ./node_modules/@packages/react-apollo-decorators/lib/withMutation.js
var withMutation = __webpack_require__(68688);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var graphql_tag_lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/mime-types/index.js
var mime_types = __webpack_require__(80983);
// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/fetch/index.js
var fetch = __webpack_require__(63144);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);
// EXTERNAL MODULE: ./src/components/fields/File/AddFile/styles.module.css
var AddFile_styles_module = __webpack_require__(7283);
var AddFile_styles_module_default = /*#__PURE__*/__webpack_require__.n(AddFile_styles_module);
;// CONCATENATED MODULE: ./src/components/fields/File/AddFile/index.tsx
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc1 = {};
    Object.keys(descriptor).forEach(function(key) {
        desc1[key] = descriptor[key];
    });
    desc1.enumerable = !!desc1.enumerable;
    desc1.configurable = !!desc1.configurable;
    if ("value" in desc1 || desc1.initializer) {
        desc1.writable = true;
    }
    desc1 = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator ? decorator(target, property, desc) || desc : desc;
    }, desc1);
    var hasAccessor = Object.prototype.hasOwnProperty.call(desc1, "get") || Object.prototype.hasOwnProperty.call(desc1, "set");
    if (context && desc1.initializer !== void 0 && !hasAccessor) {
        desc1.value = desc1.initializer ? desc1.initializer.call(context) : void 0;
        desc1.initializer = undefined;
    }
    if (hasAccessor) {
        delete desc1.writable;
        delete desc1.initializer;
        delete desc1.value;
    }
    if (desc1.initializer === void 0) {
        Object.defineProperty(target, property, desc1);
        desc1 = null;
    }
    return desc1;
}
function AddFile_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function AddFile_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function AddFile_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                AddFile_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                AddFile_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function AddFile_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function AddFile_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AddFile_getPrototypeOf(o1) {
    AddFile_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return AddFile_getPrototypeOf(o1);
}
function AddFile_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) AddFile_setPrototypeOf(subClass, superClass);
}
function AddFile_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AddFile_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AddFile_possibleConstructorReturn(self, call) {
    if (call && (AddFile_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return AddFile_assertThisInitialized(self);
}
function AddFile_setPrototypeOf(o2, p1) {
    AddFile_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return AddFile_setPrototypeOf(o2, p1);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var AddFile_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function AddFile_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function AddFile_createSuper(Derived) {
    var hasNativeReflectConstruct = AddFile_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = AddFile_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = AddFile_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return AddFile_possibleConstructorReturn(this, result);
    };
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation completeUploadAddFile($fileId: ID) {\n    completeUpload(fileId: $fileId) {\n      _id\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  mutation generateUploadCredentialsAddFile($name: String, $size: Float, $type: String) {\n    result: generateUploadCredentials(name: $name, size: $size, type: $type) {\n      fileId\n      url\n      fields\n      key\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var _Component, _Upload;
var _class, _dec, _dec1, _dec2, _dec3, _dec4, _dec5;
var _dec6 = (0,withMutation["default"])((0,graphql_tag_lib["default"])(_templateObject())), _dec7 = (0,withMutation["default"])((0,graphql_tag_lib["default"])(_templateObject1()));
var Upload = _class = _dec7(_class = _dec6(_class = (0,withMessage/* default */.Z)(((_class = (_Upload = /*#__PURE__*/ function(_superClass) {
    "use strict";
    AddFile_inherits(Upload, _superClass);
    var _super = AddFile_createSuper(Upload);
    function Upload() {
        AddFile_classCallCheck(this, Upload);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            loading: false
        };
        _this.inputRef = /*#__PURE__*/ react.createRef();
        return _this;
    }
    var _proto = Upload.prototype;
    _proto.onChange = function onChange(event) {
        var _this = this;
        return AddFile_asyncToGenerator(runtime_default().mark(function _callee() {
            var file, credentials;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        file = _this.inputRef.current.files[0];
                        _this.setState({
                            loading: true
                        });
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return _this.requestCredentials(file);
                    case 5:
                        credentials = _ctx.sent;
                        _ctx.next = 8;
                        return _this.uploadFile(credentials, file);
                    case 8:
                        _ctx.next = 10;
                        return _this.complete(credentials.fileId);
                    case 10:
                        _this.setState({
                            loading: false
                        });
                        _ctx.next = 17;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](2);
                        // @ts-expect-error ts-migrate(2339) FIXME: Property 'showMessage' does not exist on type 'Rea... Remove this comment to see the full error message
                        _this.props.showMessage(_ctx.t0);
                        _this.setState({
                            loading: false
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    13
                ]
            ]);
        }))();
    };
    _proto.requestCredentials = function requestCredentials(file) {
        var _this = this;
        return AddFile_asyncToGenerator(runtime_default().mark(function _callee() {
            var result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.props.generateUploadCredentialsAddFile({
                            name: file.name.normalize(),
                            size: file.size,
                            type: file.type || mime_types.lookup(file.name) || "application/octet-stream"
                        });
                    case 2:
                        result = _ctx.sent.result;
                        return _ctx.abrupt("return", result);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.uploadFile = function uploadFile(param, file) {
        var fields = param.fields, key = param.key, url = param.url;
        return AddFile_asyncToGenerator(runtime_default().mark(function _callee() {
            var formData, data, name;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        formData = new FormData();
                        data = AddFile_objectSpread({}, fields, {
                            key: key,
                            file: file
                        });
                        for(name in data){
                            formData.append(name, data[name]);
                        }
                        _ctx.next = 5;
                        return fetch_default()(url, {
                            method: "POST",
                            body: formData
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.complete = function complete(fileId) {
        var _this = this;
        return AddFile_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.props.completeUploadAddFile({
                            fileId: fileId
                        });
                    case 2:
                        // @ts-expect-error ts-migrate(2339) FIXME: Property 'addFile' does not exist on type 'Readonl... Remove this comment to see the full error message
                        _this.props.addFile(fileId);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.renderInput = function renderInput() {
        if (this.state.loading) return;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (AddFile_styles_module_default()).add,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                    htmlFor: "file-upload",
                    className: (AddFile_styles_module_default()).label,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdAdd */.x06, {}),
                        " Agregar archivo ",
                        this.props.accept
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    // @ts-expect-error ts-migrate(2322) FIXME: Type 'RefObject<unknown>' is not assignable to typ... Remove this comment to see the full error message
                    ref: this.inputRef,
                    id: "file-upload",
                    type: "file",
                    // @ts-expect-error ts-migrate(2339) FIXME: Property 'accept' does not exist on type 'Readonly... Remove this comment to see the full error message
                    accept: this.props.accept || "*",
                    className: (AddFile_styles_module_default()).input,
                    onChange: this.onChange
                })
            ]
        });
    };
    _proto.renderLoading = function renderLoading() {
        if (!this.state.loading) return;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (AddFile_styles_module_default()).loading,
            children: "Subiendo archivo..."
        });
    };
    _proto.render = function render() {
        return(// @ts-expect-error ts-migrate(2339) FIXME: Property 'multi' does not exist on type 'Readonly<... Remove this comment to see the full error message
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: this.props.multi ? (AddFile_styles_module_default()).multi : (AddFile_styles_module_default()).container,
            children: [
                this.renderLoading(),
                this.renderInput()
            ]
        }));
    };
    return Upload;
}(_Component = react.Component), _Upload.propTypes = {
    showMessage: (prop_types_default()).func,
    generateUploadCredentialsAddFile: (prop_types_default()).func,
    completeUploadAddFile: (prop_types_default()).func,
    addFile: (prop_types_default()).func,
    multi: (prop_types_default()).bool,
    accept: (prop_types_default()).string
}, _Upload)) || _class, _dec = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec1 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    void 0
]), _applyDecoratedDescriptor(_class.prototype, "onChange", [
    esm["default"],
    _dec,
    _dec1
], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _dec2 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec3 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    void 0
]), _applyDecoratedDescriptor(_class.prototype, "requestCredentials", [
    esm["default"],
    _dec2,
    _dec3
], Object.getOwnPropertyDescriptor(_class.prototype, "requestCredentials"), _class.prototype), _dec4 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec5 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    void 0
]), _applyDecoratedDescriptor(_class.prototype, "complete", [
    esm["default"],
    _dec4,
    _dec5
], Object.getOwnPropertyDescriptor(_class.prototype, "complete"), _class.prototype), _class)) || _class) || _class) || _class;


// EXTERNAL MODULE: ./node_modules/@packages/react-apollo-decorators/lib/withGraphQL.js
var withGraphQL = __webpack_require__(70791);
// EXTERNAL MODULE: ./src/components/fields/File/File/styles.module.css
var File_styles_module = __webpack_require__(79746);
var File_styles_module_default = /*#__PURE__*/__webpack_require__.n(File_styles_module);
;// CONCATENATED MODULE: ./src/components/fields/File/File/index.tsx
function File_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function File_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function File_getPrototypeOf(o1) {
    File_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return File_getPrototypeOf(o1);
}
function File_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) File_setPrototypeOf(subClass, superClass);
}
function File_possibleConstructorReturn(self, call) {
    if (call && (File_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return File_assertThisInitialized(self);
}
function File_setPrototypeOf(o2, p1) {
    File_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return File_setPrototypeOf(o2, p1);
}
function File_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var File_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function File_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function File_createSuper(Derived) {
    var hasNativeReflectConstruct = File_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = File_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = File_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return File_possibleConstructorReturn(this, result);
    };
}
function File_templateObject() {
    var data = File_taggedTemplateLiteral([
        "\n    query getFileInfoFileField($fileId: ID) {\n      file: fileManagerFile(fileId: $fileId) {\n        name\n        genericType\n      }\n    }\n  "
    ]);
    File_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var File_Component, _File;
var File_class;
var File_dec = (0,withGraphQL["default"])((0,graphql_tag_lib["default"])(File_templateObject()), {
    loading: null
});
var File = File_class = File_dec((File_class = (_File = /*#__PURE__*/ function(_superClass) {
    "use strict";
    File_inherits(File, _superClass);
    var _super = File_createSuper(File);
    function File() {
        File_classCallCheck(this, File);
        return _super.apply(this, arguments);
    }
    var _proto = File.prototype;
    _proto.renderLoading = function renderLoading() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (File_styles_module_default()).loading,
            children: "Cargando..."
        });
    };
    _proto.render = function render() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'file' does not exist on type 'Readonly<{... Remove this comment to see the full error message
        var _props = this.props, file = _props.file, multi = _props.multi;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
        if (this.props.loading) return this.renderLoading();
        if (!file) {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'clear' does not exist on type 'Readonly<... Remove this comment to see the full error message
            this.props.clear();
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: multi ? (File_styles_module_default()).multi : (File_styles_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (File_styles_module_default()).name,
                    children: file.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (File_styles_module_default())["delete"],
                    onClick: this.props.clear,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdClose */.FU5, {})
                })
            ]
        });
    };
    return File;
}(File_Component = react.Component), _File.propTypes = {
    file: (prop_types_default()).object,
    clear: (prop_types_default()).func,
    loading: (prop_types_default()).bool,
    multi: (prop_types_default()).bool
}, _File)) || File_class) || File_class;


// EXTERNAL MODULE: ./src/components/fields/File/styles.module.css
var fields_File_styles_module = __webpack_require__(45135);
var fields_File_styles_module_default = /*#__PURE__*/__webpack_require__.n(fields_File_styles_module);
;// CONCATENATED MODULE: ./src/components/fields/File/index.tsx
function File_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc1 = {};
    Object.keys(descriptor).forEach(function(key) {
        desc1[key] = descriptor[key];
    });
    desc1.enumerable = !!desc1.enumerable;
    desc1.configurable = !!desc1.configurable;
    if ("value" in desc1 || desc1.initializer) {
        desc1.writable = true;
    }
    desc1 = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator ? decorator(target, property, desc) || desc : desc;
    }, desc1);
    var hasAccessor = Object.prototype.hasOwnProperty.call(desc1, "get") || Object.prototype.hasOwnProperty.call(desc1, "set");
    if (context && desc1.initializer !== void 0 && !hasAccessor) {
        desc1.value = desc1.initializer ? desc1.initializer.call(context) : void 0;
        desc1.initializer = undefined;
    }
    if (hasAccessor) {
        delete desc1.writable;
        delete desc1.initializer;
        delete desc1.value;
    }
    if (desc1.initializer === void 0) {
        Object.defineProperty(target, property, desc1);
        desc1 = null;
    }
    return desc1;
}
function fields_File_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function fields_File_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function fields_File_getPrototypeOf(o1) {
    fields_File_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return fields_File_getPrototypeOf(o1);
}
function fields_File_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) fields_File_setPrototypeOf(subClass, superClass);
}
function fields_File_possibleConstructorReturn(self, call) {
    if (call && (fields_File_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return fields_File_assertThisInitialized(self);
}
function fields_File_setPrototypeOf(o2, p1) {
    fields_File_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return fields_File_setPrototypeOf(o2, p1);
}
var fields_File_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function fields_File_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function fields_File_createSuper(Derived) {
    var hasNativeReflectConstruct = fields_File_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = fields_File_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = fields_File_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return fields_File_possibleConstructorReturn(this, result);
    };
}








var fields_File_Component, _FileInput;
var fields_File_class, fields_File_dec, File_dec1;
var FileInput = ((fields_File_class = (_FileInput = /*#__PURE__*/ function(_superClass) {
    "use strict";
    fields_File_inherits(FileInput, _superClass);
    var _super = fields_File_createSuper(FileInput);
    function FileInput() {
        fields_File_classCallCheck(this, FileInput);
        return _super.apply(this, arguments);
    }
    var _proto = FileInput.prototype;
    _proto.addFile = function addFile(fileId) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'multi' does not exist on type 'Readonly<... Remove this comment to see the full error message
        if (this.props.multi) {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
            var value = clone_default()(this.props.value || []);
            value.push({
                _id: fileId
            });
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
            this.props.onChange(value);
        } else {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
            this.props.onChange({
                _id: fileId
            });
        }
    };
    _proto.deleteFile = function deleteFile(fileId) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
        this.props.onChange(this.props.value.filter(function(file) {
            return file._id !== fileId;
        }));
    };
    _proto.renderValue = function renderValue() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'multi' does not exist on type 'Readonly<... Remove this comment to see the full error message
        var _props = this.props, multi = _props.multi, value = _props.value;
        if (!value) return;
        if (multi) {
            var _this = this;
            return value.map(function(item) {
                return(// @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                /*#__PURE__*/ (0,jsx_runtime.jsx)(File, {
                    multi: true,
                    fileId: item._id,
                    clear: function() {
                        return _this.deleteFile(item._id);
                    }
                }, item));
            });
        } else {
            var _this1 = this;
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(File, {
                fileId: value._id,
                clear: function() {
                    return _this1.props.onChange(null);
                }
            });
        }
    };
    _proto.renderAddMoreFile = function renderAddMoreFile() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'multi' does not exist on type 'Readonly<... Remove this comment to see the full error message
        var _props = this.props, multi = _props.multi, accept = _props.accept;
        if (!multi) return;
        return [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (fields_File_styles_module_default()).addSeparator
            }, "sep"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Upload, {
                multi: true,
                addFile: this.addFile,
                accept: accept
            }, "add")
        ];
    };
    _proto.renderNoValue = function renderNoValue() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
        var _props = this.props, value = _props.value, multi = _props.multi, accept = _props.accept;
        if (multi) return;
        if (value) return;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Upload, {
            addFile: this.addFile,
            accept: accept
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (fields_File_styles_module_default()).mainContiaber,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "label",
                    children: this.props.label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (fields_File_styles_module_default()).container,
                    onClick: this.onClick,
                    children: [
                        this.renderNoValue(),
                        this.renderValue(),
                        this.renderAddMoreFile()
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "description",
                    children: this.props.description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "error",
                    children: this.props.errorMessage
                })
            ]
        });
    };
    return FileInput;
}(fields_File_Component = react.Component), _FileInput.propTypes = {
    value: (prop_types_default()).any,
    onChange: (prop_types_default()).func,
    openManager: (prop_types_default()).func,
    multi: (prop_types_default()).bool,
    errorMessage: (prop_types_default()).node,
    label: (prop_types_default()).node,
    description: (prop_types_default()).node,
    accept: (prop_types_default()).string
}, _FileInput)) || fields_File_class, fields_File_dec = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), File_dec1 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    void 0
]), File_applyDecoratedDescriptor(fields_File_class.prototype, "addFile", [
    esm["default"],
    fields_File_dec,
    File_dec1
], Object.getOwnPropertyDescriptor(fields_File_class.prototype, "addFile"), fields_File_class.prototype), fields_File_class);


// EXTERNAL MODULE: ./src/components/fields/Money/index.tsx + 4 modules
var Money = __webpack_require__(94083);
// EXTERNAL MODULE: ./src/hooks/useEffect.ts
var useEffect = __webpack_require__(10338);
// EXTERNAL MODULE: ./node_modules/lodash/union.js
var union = __webpack_require__(93386);
var union_default = /*#__PURE__*/__webpack_require__.n(union);
// EXTERNAL MODULE: ./src/components/fields/MultipleCheckbox/styles.module.css
var MultipleCheckbox_styles_module = __webpack_require__(43259);
var MultipleCheckbox_styles_module_default = /*#__PURE__*/__webpack_require__.n(MultipleCheckbox_styles_module);
;// CONCATENATED MODULE: ./src/components/fields/MultipleCheckbox/index.tsx






function MultipleCheckbox(props) {
    var value = props.value, onChange = props.onChange, options = props.options, defaultChecked = props.defaultChecked;
    (0,useEffect/* default */.Z)(function() {
        if (value === undefined) onChange(defaultChecked);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (MultipleCheckbox_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "label",
                children: props.label
            }),
            options.map(function(option, index) {
                var selected = (value || []).includes(option.value);
                var onClick = function(select) {
                    if (select) {
                        onChange(union_default()(value || [], [
                            option.value
                        ]));
                    } else {
                        onChange(without_default()(value, option.value));
                    }
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                    className: (MultipleCheckbox_styles_module_default()).item,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            className: (MultipleCheckbox_styles_module_default()).input,
                            checked: selected,
                            onChange: function() {
                                return onClick(!selected);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (MultipleCheckbox_styles_module_default()).label,
                            children: option.label
                        })
                    ]
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "description",
                children: props.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "os-input-error",
                children: props.errorMessage
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__(96026);
var range_default = /*#__PURE__*/__webpack_require__.n(range);
// EXTERNAL MODULE: ./src/components/fields/NextDateTime/styles.module.css
var NextDateTime_styles_module = __webpack_require__(50281);
var NextDateTime_styles_module_default = /*#__PURE__*/__webpack_require__.n(NextDateTime_styles_module);
;// CONCATENATED MODULE: ./src/components/fields/NextDateTime/index.tsx







function NextDateTime_DateTime(props) {
    var _startDayAt = props.startDayAt, startDayAt = _startDayAt === void 0 ? 11 : _startDayAt, _endDayAt = props.endDayAt, endDayAt = _endDayAt === void 0 ? 23 : _endDayAt;
    var onChange = function onChange(param) {
        var date = param.date, time = param.time;
        var instance = (0,dayjs/* default */.Z)().startOf("day").add(date, "days").add(time * 30, "minutes");
        props.onChange(instance.toDate());
    };
    var dates = range_default()(14).map(function(index) {
        var date = (0,dayjs/* default */.Z)().startOf("day").add(index, "day");
        return {
            label: date.format("LL"),
            value: "".concat(index)
        };
    });
    var times = range_default()(24 * 2).filter(function(index) {
        return index >= startDayAt * 2 && index < endDayAt * 2;
    }).map(function(index) {
        var date = (0,dayjs/* default */.Z)().startOf("day").add(index * 30, "minutes");
        return {
            label: date.format("hh:mm a"),
            value: "".concat(index)
        };
    });
    var value = {
        date: String((0,dayjs/* default */.Z)(props.value).diff((0,dayjs/* default */.Z)().startOf("day"), "day")),
        time: String((0,dayjs/* default */.Z)(props.value).diff((0,dayjs/* default */.Z)(props.value).startOf("day"), "minutes") / 30)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (NextDateTime_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "label",
                children: props.label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Form, {
                state: value,
                onChange: onChange,
                useFormTag: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-xs-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                fieldName: "date",
                                type: Select/* default */.Z,
                                options: dates,
                                placeholder: "D\xeda"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-xs-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                fieldName: "time",
                                type: Select/* default */.Z,
                                options: times,
                                placeholder: "Hora"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "description",
                children: props.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "os-input-error",
                children: props.errorMessage
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/fields/ObjectField/index.tsx
var ObjectField = __webpack_require__(47758);
// EXTERNAL MODULE: ./src/components/fields/Phone/index.tsx + 2 modules
var Phone = __webpack_require__(44682);
// EXTERNAL MODULE: ./src/components/fields/Place/index.tsx + 22 modules
var Place = __webpack_require__(9207);
;// CONCATENATED MODULE: ./src/i18n/helpers/validateID/legalIDCO.ts
var getDigitCheck = function(legalId) {
    var weights = [
        3,
        7,
        13,
        17,
        19,
        23,
        29,
        37,
        41,
        43,
        47,
        53,
        59,
        67,
        71
    ];
    var legalIdValues = legalId.split("").map(function(val) {
        return parseInt(val);
    }).reverse();
    if (legalIdValues.length >= 15) return "";
    var sumProduct = legalIdValues.reduce(function(acc, val, index) {
        return acc + val * weights[index];
    }, 0);
    if (isNaN(sumProduct)) return "";
    var result = sumProduct % 11;
    return result > 1 ? "".concat(11 - result) : "".concat(result);
};
var getLegalIdParts = function(legalId) {
    var split = legalId.split("-");
    var base = split[0];
    var digitCheck = split[1] || getDigitCheck(base);
    return [
        base,
        digitCheck
    ];
};
/* harmony default export */ var legalIDCO = (getLegalIdParts);

;// CONCATENATED MODULE: ./src/i18n/helpers/validateID/index.ts

/* harmony default export */ var validateID = ({
    CO: legalIDCO
});

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./src/components/fields/ReceiverDataCO/styles.module.css
var ReceiverDataCO_styles_module = __webpack_require__(25285);
var ReceiverDataCO_styles_module_default = /*#__PURE__*/__webpack_require__.n(ReceiverDataCO_styles_module);
;// CONCATENATED MODULE: ./src/components/fields/ReceiverDataCO/index.tsx
function ReceiverDataCO_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ReceiverDataCO_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ReceiverDataCO_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ReceiverDataCO_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ReceiverDataCO_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ReceiverDataCO_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ReceiverDataCO_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ReceiverDataCO_slicedToArray(arr, i) {
    return ReceiverDataCO_arrayWithHoles(arr) || ReceiverDataCO_iterableToArrayLimit(arr, i) || ReceiverDataCO_unsupportedIterableToArray(arr, i) || ReceiverDataCO_nonIterableRest();
}
function ReceiverDataCO_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ReceiverDataCO_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ReceiverDataCO_arrayLikeToArray(o, minLen);
}










function ReceiverDataCO(props) {
    var ref2 = ReceiverDataCO_slicedToArray((0,useState/* default */.Z)(0), 2), id = ref2[0], setId = ref2[1];
    var ref1 = ReceiverDataCO_slicedToArray((0,useState/* default */.Z)(""), 2), idType = ref1[0], setIdType = ref1[1];
    var handlerStates = function() {
        if (!props.value) return;
        setId(props.value.identification || "");
        setIdType(props.value.identifierType || "");
        if (props.value.responsibilities && props.value.responsibilities.length === 0) {
            props.onChange(ReceiverDataCO_objectSpread({}, props.value, {
                responsibilities: null
            }));
        }
        if (props.value.digitCheck !== "" && props.value.identifierType === "22") {
            props.onChange(ReceiverDataCO_objectSpread({}, props.value, {
                digitCheck: ""
            }));
        }
    };
    (0,useEffect/* default */.Z)(function() {
        handlerStates();
    }, [
        props.value
    ]);
    (0,useEffect/* default */.Z)(function() {
        if (!props.value) return function() {};
        if (!props.value.identification) {
            props.onChange(ReceiverDataCO_objectSpread({}, props.value, {
                digitCheck: ""
            }));
        } else {
            var ref = ReceiverDataCO_slicedToArray(validateID.CO(props.value.identification || []), 2), _ = ref[0], dv = ref[1];
            props.onChange(ReceiverDataCO_objectSpread({}, props.value, {
                digitCheck: dv
            }));
        }
    }, [
        id,
        idType
    ]);
    var schema = get_default()(props, "passProps.data.type");
    var _personType = schema.personType, _fieldOptions = _personType.fieldOptions, personTypeOptions = _fieldOptions.options, _identifierType = schema.identifierType, _fieldOptions1 = _identifierType.fieldOptions, identifierTypeOptions = _fieldOptions1.options, _regimeType = schema.regimeType, _fieldOptions2 = _regimeType.fieldOptions, regimeTypeOptions = _fieldOptions2.options, _responsibilities = schema.responsibilities, _fieldOptions3 = _responsibilities.fieldOptions, responsibilitiesOptions = _fieldOptions3.options, _address = schema.address, _type = _address.type, _billingCityCode = _type.billingCityCode, _fieldOptions4 = _billingCityCode.fieldOptions, billingCityCodeOptions = _fieldOptions4.options, _billingRegionCode = _type.billingRegionCode, _fieldOptions5 = _billingRegionCode.fieldOptions, billingRegionCodeOptions = _fieldOptions5.options, _billingCountryCode = _type.billingCountryCode, _fieldOptions6 = _billingCountryCode.fieldOptions, billingCountryCodeOptions = _fieldOptions6.options;
    var showBillingRegionCode = get_default()(props, "value.address.billingCountryCode");
    var showBillingCityCode = showBillingRegionCode && get_default()(props, "value.address.billingRegionCode");
    var showBillingAddress = showBillingCityCode && get_default()(props, "value.address.billingCityCode");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ReceiverDataCO_styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib.Form, {
            state: props.value,
            onChange: props.onChange,
            useFormTag: false,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                    label: "Tipo",
                    fieldName: "personType",
                    type: Select/* default */.Z,
                    options: personTypeOptions
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                    label: "Tipo de identificaci\xf3n",
                    fieldName: "identifierType",
                    type: Select/* default */.Z,
                    options: identifierTypeOptions
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ReceiverDataCO_styles_module_default()).idContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ReceiverDataCO_styles_module_default()).idContainer__id,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                label: "Identificaci\xf3n",
                                placeholder: "CC/NIT",
                                fieldName: "identification",
                                type: Text/* default */.Z
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ReceiverDataCO_styles_module_default()).idContainer__dv,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                label: "DV",
                                fieldName: "digitCheck",
                                type: Text/* default */.Z,
                                disabled: true
                            })
                        })
                    ]
                }),
                get_default()(props, "value.personType") === "2" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                            label: "Nombres",
                            fieldName: "firstName",
                            type: Text/* default */.Z
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                            label: "Apellidos",
                            fieldName: "lastName",
                            type: Text/* default */.Z
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                    label: "Raz\xf3n social",
                    fieldName: "companyName",
                    type: Text/* default */.Z
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                    label: "Email",
                    fieldName: "email",
                    type: Text/* default */.Z,
                    fieldType: "email"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                    label: "Tipo de r\xe9gimen",
                    fieldName: "regimeType",
                    type: Select/* default */.Z,
                    options: regimeTypeOptions
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                    label: "Responsabilidad fiscal",
                    fieldName: "responsibilities",
                    type: Select/* default */.Z,
                    multi: true,
                    options: responsibilitiesOptions
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                    label: "Pa\xeds",
                    fieldName: "address.billingCountryCode",
                    type: Select/* default */.Z,
                    options: billingCountryCodeOptions
                }),
                showBillingRegionCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                    label: "Regi\xf3n",
                    fieldName: "address.billingRegionCode",
                    type: Select/* default */.Z,
                    options: billingRegionCodeOptions
                }) : null,
                showBillingCityCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                    label: "Ciudad",
                    fieldName: "address.billingCityCode",
                    type: Select/* default */.Z,
                    options: billingCityCodeOptions.filter(function(city) {
                        return city.value.startsWith(props.value.address.billingRegionCode);
                    })
                }) : null,
                showBillingAddress ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                    label: "Direccion",
                    fieldName: "address.billingAddress",
                    type: Text/* default */.Z
                }) : null
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/fields/SixDigitInput/index.tsx
var SixDigitInput = __webpack_require__(64661);
// EXTERNAL MODULE: ./src/helpers/websites/withWebsiteId.tsx
var withWebsiteId = __webpack_require__(91015);
;// CONCATENATED MODULE: ./src/components/fields/Store/index.tsx
function Store_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function Store_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function Store_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Store_getPrototypeOf(o1) {
    Store_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return Store_getPrototypeOf(o1);
}
function Store_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Store_setPrototypeOf(subClass, superClass);
}
function Store_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Store_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Store_possibleConstructorReturn(self, call) {
    if (call && (Store_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return Store_assertThisInitialized(self);
}
function Store_setPrototypeOf(o2, p1) {
    Store_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return Store_setPrototypeOf(o2, p1);
}
function Store_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var Store_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function Store_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function Store_createSuper(Derived) {
    var hasNativeReflectConstruct = Store_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = Store_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = Store_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return Store_possibleConstructorReturn(this, result);
    };
}
function Store_templateObject() {
    var data = Store_taggedTemplateLiteral([
        "\n  query getStoresStoreField($websiteId: ID) {\n    stores(websiteId: $websiteId) {\n      items {\n        value: _id\n        label: name\n        acceptServe\n      }\n    }\n  }\n"
    ]);
    Store_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Store_Component, _Store;
var Store_class;
var Store_dec = (0,withGraphQL["default"])((0,graphql_tag_lib["default"])(Store_templateObject()));
var Store = Store_class = (0,withWebsiteId/* default */.Z)(Store_class = Store_dec((Store_class = (_Store = /*#__PURE__*/ function(_superClass) {
    "use strict";
    Store_inherits(Store, _superClass);
    var _super = Store_createSuper(Store);
    function Store() {
        Store_classCallCheck(this, Store);
        return _super.apply(this, arguments);
    }
    var _proto = Store.prototype;
    _proto.render = function render() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'stores' does not exist on type 'Readonly... Remove this comment to see the full error message
        var _props = this.props, stores = _props.stores, acceptServe = _props.acceptServe, validStoresIds = _props.validStoresIds;
        if (!stores) return null;
        var options = stores.items.filter(function(store) {
            if (validStoresIds && !validStoresIds.includes(store.value)) return false;
            if (!acceptServe) return true;
            return store.acceptServe;
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, Store_objectSpread({}, this.props, this.props.passProps, {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'passProps' does not exist on type 'Reado... Remove this comment to see the full error message
            passProps: this.props.passProps,
            options: options
        }));
    };
    return Store;
}(Store_Component = react.Component), _Store.propTypes = {
    passProps: (prop_types_default()).object,
    stores: (prop_types_default()).object,
    acceptServe: (prop_types_default()).bool,
    validStoresIds: prop_types_default().arrayOf((prop_types_default()).string)
}, _Store)) || Store_class) || Store_class) || Store_class;


// EXTERNAL MODULE: ./src/components/fields/Stores/index.tsx + 2 modules
var Stores = __webpack_require__(1955);
;// CONCATENATED MODULE: ./src/components/fields/index.ts












// import DriversZones from './DriversZones'
// import FileManager from './FileManager'
// import Categories from './Categories'
// import Options from './Options'
// import MultipleMoney from './MultipleMoney'
// import MarkerArray from './MarkerArray'
// import Schedule from './Schedule'
// import DateArray from './DateArray'
// import SelectImage from './SelectImage'
// import Category from './Category'
// import Percentage from '@packages/justo-parts/lib/components/fields/numeral/Percentage'




// import Menus from './Menus'
// import ColorPicker from './ColorPicker'
// import WebsitesIds from './WebsitesIds'
// import Font from './Font'
// import Products from './Products'
// import Image from './Image'
// import StringArray from './StringArray'
// import InstagramUserId from './InstagramUserId'
// import ReceiverData from './ReceiverData'
// import Brand from './Brand'
// import User from './User'
// import Segment from './Segment'
// import MonthSelector from './MonthSelector'
// import InStoreCoupon from './InStoreCoupon'
// import Modifiers from './Modifiers'
// import City from './City'
// import Order from './Order'
// import OrderStatus from './OrderStatus'
// import SelectJustos from './SelectJustos'
// import PaymentType from './PaymentType'
// import Country from './Country'
// import Product from './Product'
// import AppCampaigns from './AppCampaigns'




// import WebhookTypes from './WebhookTypes'
// import customCOLegalID from './customCOLegalID'
// import customCOAddress from './customCOAddress'
// import ExternalCompanyIds from './ExternalCompanyIds'
// import StoresByWebsites from './StoresByWebsites'
// import SpecialDelivery from './SpecialDelivery'
// import TrackedDrivers from './TrackedDrivers'
// import UserCurrency from './UserCurrency'
// import HttpPostOptions from './HttpPostOptions'
// import CityWithEdit from './CityWithEdit'
// import PaymentMethods from './PaymentMethods'
// import CustomCOAddressBilling from './CustomCOAddressBilling'
var autoformFields = {
    // trackedDrivers: TrackedDrivers,
    // country: Country,
    // selectJustos: SelectJustos,
    // monthSelector: MonthSelector,
    // modifiers: Modifiers,
    // orderId: Order,
    // orderStatus: OrderStatus,
    phone: Phone/* default */.Z,
    // percentage: Percentage,
    string: Text/* default */.Z,
    // brand: Brand,
    textarea: Textarea/* default */.Z,
    email: Text/* default */.Z,
    // cityId: City,
    // fileManager: FileManager,
    file: FileInput,
    // image: Image,
    money: Money/* default */.Z,
    number: numeral_Number/* default */.Z,
    array: ArrayComponent_Array,
    plainObject: ObjectField/* default */.Z,
    // dateArray: DateArray,
    // '[date]': DateArray,
    // segment: Segment,
    // schedule: Schedule,
    boolean: Checkbox/* default */.Z,
    multipleCheckbox: MultipleCheckbox,
    date: DateText/* default */.Z,
    datetime: DateTime,
    // markerArray: MarkerArray,
    sixDigit: SixDigitInput/* default */.Z,
    // multipleMoney: MultipleMoney,
    select: Select/* default */.Z,
    // categories: Categories,
    // category: Category,
    stores: Stores/* default */.Z,
    store: Store,
    // storesByWebsites: StoresByWebsites,
    // options: Options,
    place: Place/* default */.Z,
    // inStoreCoupon: InStoreCoupon,
    // colorPicker: ColorPicker,
    // '[string]': StringArray,
    // stringArray: StringArray,
    // selectImage: SelectImage,
    nextDateTime: NextDateTime_DateTime,
    // menus: Menus,
    // websitesIds: WebsitesIds,
    // websites: WebsitesIds,
    // font: Font,
    // product: Product,
    // products: Products,
    // instagramUserId: InstagramUserId,
    // receiverData: ReceiverData,
    // user: User,
    // paymentType: PaymentType,
    // appCampaigns: AppCampaigns,
    receiverDataCO: ReceiverDataCO,
    // webhookTypes: WebhookTypes,
    // customCOLegalID,
    // customCOAddress,
    // externalCompanyIds: ExternalCompanyIds,
    // deliveryId: SpecialDelivery,
    // driversZones: DriversZones,
    // UserCurrency,
    datepicker: DatePicker
};
/* harmony default export */ var fields = (autoformFields);


/***/ }),

/***/ 91015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createWithWebsiteId; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _providers_WebsiteIdContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70880);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function createWithWebsiteId(ComposedComponent) {
    return function WithWebsiteId(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_providers_WebsiteIdContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Consumer */ .Z.Consumer, {
            children: function(contextWebsiteId) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ComposedComponent, _objectSpread({}, props, {
                    websiteId: contextWebsiteId
                }));
            }
        });
    };
};


/***/ }),

/***/ 10754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1oy5o8WIeh7xEGf5klJ-In","header":"_1ad_3zcnCZJsA08vCsSm38","label":"_3Bu-Sn-bSIb3fqggbmh6Ip","content":"_2ZYu3EJ1x23WWruvKT1wZz"};

/***/ }),

/***/ 42889:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3eyHJVvAgHLyur5zLB-MrS","description":"_1TcS4AQFZFEB4ZXeRdHJq description"};

/***/ }),

/***/ 70898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2sB_syUmnYBtP5yZGhF-Cq","message":"_2OVIzhi67_H3z2ozkrRbVN","datePicker":"_1jmQ3Sw9_45QuzHam9yGP_","datePickerContainer":"_3w_2_aJ7YFuwWrN7QaIRCN","label":"_3qPPiHZJc9I1FwLWWJ3QJE","separator":"_33OAAAc0z_gdkFSTykq3C_","icon":"Px91XwaO35gPNmedCLQNe"};

/***/ }),

/***/ 44122:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ncN4Q3sgmBV0Fxa3OUvY5","inputs":"zZuRRsQkPHOfrE3AAmgQE","label":"_1W1uLkNW4APj-DBae68GA0"};

/***/ }),

/***/ 7283:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NtxXeLYrkNvMiPCKaSnBj","multi":"_2JWksj2TjP-_AvGUvc8454 NtxXeLYrkNvMiPCKaSnBj","add":"_3ZnCF8lm-FUmjkmGZ4ytWA","label":"ApUxS8F5JUuT6KTL1PDgT buttonShadow","loading":"_1Wa2hbbKU-yj0uEZ_rFaHh","input":"_1QotrRDgOrncucqMn1guiu"};

/***/ }),

/***/ 79746:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"YhH6777r6kJyh0a0lFEgr","multi":"_16r0IoGh8WjQCvN5tQWQCz YhH6777r6kJyh0a0lFEgr","name":"_2xWE12nFUJdEYMBSvwNnqs","delete":"M6_CoSdhBIg1S1-sV9MM_","loading":"_1_i1XdjJTO3tmuNwbOu11C YhH6777r6kJyh0a0lFEgr"};

/***/ }),

/***/ 45135:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainContiaber":"_13EtqHRDNM1whHA2iG2m8e","container":"_23QAr-DXfkur41JXGntH4x","noValue":"_2qJZ0fkZLdhaJgJpyzDvXk","addSeparator":"_39mhOt0muOiKRszpHilh5U"};

/***/ }),

/***/ 35901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"iOloMqpXgcETGYqgpgRfB","domain":"-iROtochRF2c1HdDzTwh","input":"_1q4rXLHSBW89RUUW8kvqUa","icon":"_2XQ7V1NcVa6INd4SFc2zg8"};

/***/ }),

/***/ 43259:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3TtYa3Dc1kYbHyFCKjxjdM","item":"_2gWR_6fuBwrPp2-cTGKD1k","input":"_1XDEVmXkWdQOuGiSGrtifX"};

/***/ }),

/***/ 50281:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"XY1ijAsWdXUcXAM0CT6Qq"};

/***/ }),

/***/ 41423:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3BxvKoklyzMW1gAZOy0jlW","digit":"_2uI-5k43viTOL8uRqXGRt3"};

/***/ }),

/***/ 25285:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"mLsm4V4zs77RYfyputamR","idContainer":"_2RKJOUmWm-rYjxZ7zRoZAr","idContainer__id":"_2fbUOPyRuml-N-NNZTUdn8","idContainer__dv":"_2QS3UZujmHXZPw4E_7rqz0"};

/***/ }),

/***/ 4972:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2KMpxbIJeQz036jY8tzTq8","ready":"_3xyKUXp3rmu8ypI7UaA-66 _2KMpxbIJeQz036jY8tzTq8","input":"_3Vhdoe5QaDAmqyj1rdiudn"};

/***/ })

}]);